export const API_URL = "https://masakapi.justalp.com/api"